import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  Dictionary,
  ReadonlyHttpApiRepository,
  Result,
} from '@softline/core';
import { SOFTLINE_API_LIEFERANTENSTAMM } from '../lieferantenstamm.api';
import { LieferantenQuery } from '../types/lieferanten-query';
import { Supplier } from '@softapps/wws/core';

@Injectable()
export class LieferantenRepository extends ReadonlyHttpApiRepository<
  Result<Supplier>,
  LieferantenQuery
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_LIEFERANTENSTAMM);
  }

  override getLoadPathParams(params: LieferantenQuery): Dictionary<unknown> {
    return { id: params.id };
  }
}
